import { render, staticRenderFns } from "./AdminCoachAutocomplete.vue?vue&type=template&id=f5e8c688&"
import script from "./AdminCoachAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./AdminCoachAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports